import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(example, pagable);
    return httpService.get("/outgoingDocReceivers", {params: params});
  },

  findAllCC(docId) {
    let params = { docId };
    return httpService.get("/outgoingDoc/listCCVanBan", {params: params});
  }
}



// WEBPACK FOOTER //
// ./src/services/outgoingDocReceiversService.js